import { Provider } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { SelfFixEffects } from '../+state/self-fix.effects';

export function provideSelfFixStore(): Provider {
  return [provideEffects([SelfFixEffects])];
}
